import { mapActions, mapGetters } from 'vuex';
import stateIcon from '@/components/wallet/pending-requests/state-icon/state-icon.vue';
import { dateToString } from '@/utils/helpers';
import loaderMixin from '@/mixins/loader';
import { $txt } from '@/mixins/staticConf/utils';

const STATUS_CANCELLABLE = 'Pending Approval';
const BASIC_COLUMN_SET = [
  'DEPOSITS',
  'PROMOTIONS',
];

const DIMMED_STATUS_LIST = [
  'Cancelled',
  'Rejected',
  'Returned',
  'Not Approved',
];

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    stateIcon,
  },
  props: {
    type: {
      type: String,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    itemDate() {
      return dateToString(this.item.date);
    },
    classModifier() {
      return {
        'balance-history-item--dimmed': DIMMED_STATUS_LIST.includes(this.item.status),
      };
    },
    showAdditionalColumns() {
      return (!BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop);
    },
    amountColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns,
      };
    },
    typeColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns,
      };
    },
    statusColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns,
      };
    },
  },
  methods: {
    ...mapActions('wallet', ['cancelWithdrawal']),
    ...mapActions('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']),
    showCancelRequestButton(item) {
      return item.status === STATUS_CANCELLABLE && item.withdrawalId;
    },
    onCancelRequest(item) {
      const payload = {
        withdrawalId: item.withdrawalId,
      };
      this.loaderAdd();
      this.cancelWithdrawal(payload)
        .then(() => this.loaderRemove())
        .then(() => this.setSuccessSideNotification($txt('balance-history-item.canceled')))
        .then(() => this.$emit('itemCancelled', item))
        .catch(() => {
          this.loaderRemove();
          this.setErrorSideNotification($txt('balance-history-item.failed'));
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/balance-history/balance-history-item/balance-history-item.js